module.exports = __webpack_public_path__ + "2390eee383cdb7fd1a57b50fb6fc1c03.png";